import React, { useEffect, useRef, useState } from "react"
import { getAudioInputDeviceData } from "../../base/devices";
import { Progressbar } from "../../base/canvas";

import { translate } from "../../base/i18n";
import { setAudioMuted } from "../../base/media";
import { connect } from "../../base/redux";
import { SelectDevice } from "./DeviceSelect";
import { isIOSDevice } from "../../base/util";
import { BsFillMicFill, BsFillMicMuteFill } from "react-icons/bs";

const getMimeType = () => {
    let mimeType = "video/mp4";

    if (MediaRecorder.isTypeSupported("video/webm")) mimeType = "video/webm";
    
    return mimeType;
}

class Record {
    constructor(handler) {
        this.audioContext;
        this.recordingData;
        this.stream = new Map();
        this.recorder;
        this.handler = handler;

        var audioContext = window.AudioContext;
        if (typeof audioContext === undefined) {
            if (typeof window.webkitAudioContext !== undefined) {
                /*global AudioContext:true */
                audioContext = window.webkitAudioContext;
            }
    
            if (typeof window.mozAudioContext !== undefined) {
                /*global AudioContext:true */
                audioContext = window.mozAudioContext;
            }
        }

        this.audioContext = audioContext;

        this.storage = {
            AudioContext: null,
            AudioContextConstructor: null
        };
        if (typeof audioContext !== undefined) {
            this.storage.AudioContext = audioContext;
        } else if (typeof window.webkitAudioContext !== undefined) {
            this.storage.AudioContext = window.webkitAudioContext;
        }
    }

    isSupportedBrowser() {
        if (this.audioContext === undefined) return false;
        if (typeof MediaRecorder === undefined) return false;
        
        return true;
    }

    loadAudioStraem(audioTrack) {
        if (!this.storage.AudioContextConstructor) {
            this.storage.AudioContextConstructor = new this.storage.AudioContext();
        }

        this.audioContext = this.storage.AudioContextConstructor;
        this.audioSource;
        
        this.gainNode = this.audioContext.createGain();
        this.gainNode.connect(this.audioContext.destination);
        this.gainNode.gain.value = 0;

        this.audioDestination = this.audioContext.createMediaStreamDestination();

        const stream = audioTrack;
        
        var audioSource = this.audioContext.createMediaStreamSource(stream);
        audioSource.connect(this.gainNode);

        this.audioSource = audioSource;

        this.stream = audioTrack;
    }

    getMixedAudioStream() {
        this.audioSource.connect(this.audioDestination);

        return this.audioDestination.stream;
    }
    
    async start(element) {
        let recordingData = this.recordingData;

        try {            
            var mixedAudioStream = this.getMixedAudioStream();
            var mixTracks = mixedAudioStream.getTracks();
            var resultStream = new MediaStream(mixTracks);

            this.recorder = new MediaRecorder(resultStream, {mimeType: getMimeType(), disableLogs: false});
            this.recorder.ondataavailable = async e => {
                if (e.data && e.data.size > 0) {
                    recordingData = e.data;
                    // 녹화 데이터 저장 
                    
                    this.handler.setRecordTrack(recordingData);
                    setTimeout(() => {
                        this.audioContext.resume().then(() => {
                            
                            console.log('Playback resumed successfully');
                        });                    
                    }, 1000);
                    
                }
            };

            // 녹화 시작 
            this.recorder.start();
        } catch (e) {
            console.error("capture failure", e);
            return;
        }
    }

    stop() {
        this.recorder && this.recorder.state === 'recording' && this.recorder.stop();
    }
}


let initStatus = {
    type: "ok",
    message: "device.microphoneOk"
};

function SelectAudioInput({
    t, dispatch, list, isRoom,
    didMount, micId, setSelectMic
}) {
    const audioTrackElement = useRef();
    const [ currentStream, setCurrentStream ] = useState(null);
    const [ status, setStatus ] = useState(initStatus);
    const [ isRecording, setIsRecording ] = useState(false);
    const [ file, setFile ] = useState();

    useEffect(() => {
        return () => {
            APP.mateManagement.listenForAudioUpdates();
        }
    }, []);

    useEffect(() => {
        if (didMount) setMicTrack();
        else stopMediaTracks(currentStream);
    }, [didMount]);

    useEffect(() => {
        if (didMount) setMicTrack();
    }, [micId]);

    useEffect(() => {
        if (currentStream) {
            APP.mateManagement.listenForAudioUpdates(currentStream);
        }
        
        return async () => {
            if (typeof currentStream !== 'undefined' && currentStream) {
                stopMediaTracks(currentStream);
            }
        }
    }, [currentStream]);

    useEffect(() => {
        if (isRecording) {
            const handler = {
                setRecordTrack: (test) => {
                    if (file) URL.revokeObjectURL(file);

                    const blobUrl = URL.createObjectURL(test);
                    setFile(blobUrl);

                    setIsRecording(false);
                }
            };
            const record = new Record(handler);
            if (!record.isSupportedBrowser()) {
                alert("녹화를 지원하지 않는 브라우저입니다.");
                return;
            }
            if (!currentStream) {
                return;
            }
            
            record.loadAudioStraem(currentStream);
            record?.start(audioTrackElement?.current);
            setTimeout(() => {
                record.stop();
            }, 4000);
        }
    }, [isRecording]);

    const stopMediaTracks = (stream) => {
        stream && stream.getTracks().forEach(track => {
            track.stop();
        });

        setCurrentStream(null);
    }

    const setMicTrack = async () => {
        if (!didMount) return;

        if (typeof currentStream !== 'undefined' && currentStream && micId) {
            await stopMediaTracks(currentStream);
        }
        
        APP.UI.showLoading(true);
        navigator.mediaDevices.getUserMedia({
            video: false, 
            audio:  { deviceId: micId }
        }).then(stream => {
            setCurrentStream(stream);
            setStatus(initStatus);

            if (stream) {
                const deviceId = stream.getAudioTracks()[0].getSettings().deviceId;
                deviceId && deviceId !== micId && setSelectMic(deviceId);
            }            

            APP.UI.showLoading(false);
        }).catch(async err => {

            const status = await APP.mateManagement.getMicErrorMsg(err);
            setStatus(status);

            APP.UI.showLoading(false);
        });
    }

    const _setAudioMuted = e => {        
        dispatch(setAudioMuted(e.target.checked));
    };  
    
    const setMuted = () => {
        setIsRecording(!isRecording);
    };

    return (
        <>
            <dt> { t("device.audioInputSetting") } </dt>            
            <SelectDevice 
                t={t}
                list={list} 
                deviceId={micId} 
                setDeviceId={setSelectMic} 
                deviceStatus={status}
            >
                { APP.function.setDevice.micTest && status.type === 'ok' && <button className={`btn btn_middle ${isRecording ? "btn_on" : ""}`} onClick={setMuted}>
                    {t(`device.deviceTest`)}
                </button> }
            </SelectDevice>

            <dd className="mute_check nonSelect">
                { !isRoom && <div className="mute_check nonSelect">
                    <input type="checkbox" onChange={_setAudioMuted} id="audioMuteBtn" disabled={status.type === 'ok' ? false : true} />
                    <label htmlFor="audioMuteBtn">
                        <span>{t("device.hideAudio")}</span>
                    </label>
                </div>}

                { isRoom && (
                    status.type === 'ok' ? <BsFillMicFill size={12} /> : <BsFillMicMuteFill size={12} color='#ed1e1e' />
                 ) }

                <Progressbar className="mute_range">
                    <input id="audioLevel" className="audio_level" type="range" name="range" />
                </Progressbar>

                <div style={{textAlign: "center", flex: 0}}>
                    <audio preload="auto" autoPlay 
                        webkit-playsinline="webkit-playsinline"
                        playsInline="playsInline"
                        ref={audioTrackElement} src={file}
                    /> 
                </div>
            </dd>
            <dd>
                <span className="guid">{t(`device.audioInputGuid`)}</span>
                <br/>
                { isIOSDevice() && <span className="guid" style={{ color: "red" }}>{ t("device.iosError") } </span> }
            </dd>  
        </>
    )
}

function _mapStateToProps(state) {
    const list = getAudioInputDeviceData(state);
    
    return {
        list
    }
}

export default translate(connect(_mapStateToProps)(SelectAudioInput));